/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./CountryFlag.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var atSvg = require("../img/metro/flags/at.svg");
var beSvg = require("../img/metro/flags/be.svg");
var bgSvg = require("../img/metro/flags/bg.svg");
var cnSvg = require("../img/metro/flags/cn.svg");
var czSvg = require("../img/metro/flags/cz.svg");
var deSvg = require("../img/metro/flags/de.svg");
var esSvg = require("../img/metro/flags/es.svg");
var frSvg = require("../img/metro/flags/fr.svg");
var hrSvg = require("../img/metro/flags/hr.svg");
var huSvg = require("../img/metro/flags/hu.svg");
var inSvg = require("../img/metro/flags/in.svg");
var itSvg = require("../img/metro/flags/it.svg");
var jpSvg = require("../img/metro/flags/jp.svg");
var kzSvg = require("../img/metro/flags/kz.svg");
var mdSvg = require("../img/metro/flags/md.svg");
var nlSvg = require("../img/metro/flags/nl.svg");
var pkSvg = require("../img/metro/flags/pk.svg");
var plSvg = require("../img/metro/flags/pl.svg");
var ptSvg = require("../img/metro/flags/pt.svg");
var roSvg = require("../img/metro/flags/ro.svg");
var rsSvg = require("../img/metro/flags/rs.svg");
var ruSvg = require("../img/metro/flags/ru.svg");
var skSvg = require("../img/metro/flags/sk.svg");
var trSvg = require("../img/metro/flags/tr.svg");
var uaSvg = require("../img/metro/flags/ua.svg");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-countryFlag");
exports.flagTypes = {
    at: atSvg,
    be: beSvg,
    bg: bgSvg,
    cn: cnSvg,
    cz: czSvg,
    de: deSvg,
    es: esSvg,
    fr: frSvg,
    hr: hrSvg,
    hu: huSvg,
    in: inSvg,
    it: itSvg,
    jp: jpSvg,
    kz: kzSvg,
    md: mdSvg,
    nl: nlSvg,
    pk: pkSvg,
    pl: plSvg,
    pt: ptSvg,
    ro: roSvg,
    rs: rsSvg,
    ru: ruSvg,
    sk: skSvg,
    tr: trSvg,
    ua: uaSvg
};
var getFlagImageSrc = function (type) { return exports.flagTypes[type]; };
exports.CountryFlag = function CountryFlag(_a) {
    var className = _a.className, htmlAlt = _a.htmlAlt, type = _a.type;
    return (React.createElement("span", { className: moduleClassName() },
        React.createElement("img", { src: getFlagImageSrc(type), alt: htmlAlt, className: moduleClassName("img") }),
        React.createElement("span", { className: moduleClassName("shadow") })));
};
exports.CountryFlag.propTypes = {
    className: PropTypes.string,
    htmlAlt: PropTypes.string,
    type: PropTypes.oneOf(Object.keys(exports.flagTypes)).isRequired
};